export default {
    upload_image_title: "Insert Image",
    upload_image_label: "Upload a new image or choose one of the previously uploaded images",
    upload_image_insert: "Insert",
    upload_image_size_exceeds: "Image size exceeds 10 mb",
    upload_image_drap_drop: "Drag 'n' drop some image here, or click to select image",
}